// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c7VIFi4z7IMUSJbP{display:flex;justify-content:center;flex-direction:column;height:100%}.c7VIFi4z7IMUSJbP .Im3Aqte6gCAE3IlQ{margin-top:-16px}.c7VIFi4z7IMUSJbP .sEdba9TXmNwGHxq2{padding-top:8px;width:100%}.c7VIFi4z7IMUSJbP .DG27Lyc8sgpxJ2zE{position:absolute;display:flex;justify-content:center;height:100%;width:100%;align-items:center}.c7VIFi4z7IMUSJbP .DG27Lyc8sgpxJ2zE .llGzPeVoc8MorSYl{width:234px;text-align:center;z-index:1}.c7VIFi4z7IMUSJbP .PKGetdqP1JoXBPUs{height:240px}.c7VIFi4z7IMUSJbP .LPYMEKEup49vkhiB{height:100%;width:100%;display:flex;justify-content:center;align-items:center}.c7VIFi4z7IMUSJbP .I3Xw3jgQm7MqKOII{display:flex}.c7VIFi4z7IMUSJbP .I3Xw3jgQm7MqKOII .svKIxL0_fbILBSpH{display:flex;align-items:center;border-radius:4px;padding:4px;gap:5.5px}.c7VIFi4z7IMUSJbP .I3Xw3jgQm7MqKOII .svKIxL0_fbILBSpH .xN4JEevQDx8WGXES{opacity:.8}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `c7VIFi4z7IMUSJbP`,
	"emptyChartContainer": `Im3Aqte6gCAE3IlQ`,
	"trendlineChartContainer": `sEdba9TXmNwGHxq2`,
	"noDataMessage": `DG27Lyc8sgpxJ2zE`,
	"noMessageText": `llGzPeVoc8MorSYl`,
	"trendChart": `PKGetdqP1JoXBPUs`,
	"spinnerContainer": `LPYMEKEup49vkhiB`,
	"legend": `I3Xw3jgQm7MqKOII`,
	"legendLabel": `svKIxL0_fbILBSpH`,
	"legendText": `xN4JEevQDx8WGXES`
};
export default ___CSS_LOADER_EXPORT___;
